const langKR = {
	"GAS_FEES" : "Nebulas 네트워크 가스 요금",
	"TX_WARNING" : "경고! Nebulas 스트레스하에 거래 시간은 현재 알 수 없습니다.",
	"COLLECT" : "수집",
	"COLLECT_DESCRIPTION" : "디지털 자산을 마음 속의 콘텐츠로 수집하십시오! 각 카드는 무작위로 생성되며 특정 통계 및 특성에 해당하는 고유 한 ID를 포함합니다.",
	"BATTLE" : "전투",
	"TRADE" : "무역",
	"GET_COLLECTIBLES" : "수집품 가져와!",
	"PLEASE_WAIT" : "잠시만 기다려주십시오 ...",
	"VS" : "대",
	"BATTLE_NOW" : "지금 전투",
	"CREATE_AUCTION" : "경매 만들기",
	"TRADE_DESCRIPTION" : "높은 평점과 고유 카드를 보유하고 계십니까? 잠재적으로 수익을 낼 수 있습니다! 가격에 이름을 지정하고 경매를 통해 잠재 구매자를 유치하십시오.",
	"BATTLE_DESCRIPTION" : "자신이 소유 한 카드를 전투와 레벨 업! 매 승리마다 새로운 카드를 얻습니다. 그러나 손실은 카드를 잃는 것을 의미합니다! 등급이 높은 카드는 더 가치가 있기 때문에 전투가 매우 효과적 일 수 있습니다.",
	"BANNER_HEADER" : "수집, 전투 및 무역",
	"BRAND_HEADER" : "BATTLE BLOCKS",
	"BRAND_SUBHEADER" : "블록 체인에서 수집 가능한 디지털 자산 수집",
	"LOADING" : "로드 중 ...",
	"CARDS_CREATED" : "생성 된 카드",
	"PENDING_TRANSACTION" : "보류중인 거래",
	"SAVE" : "구하다",
	"USER_LOADING" : "사용자로드 중 ...",
	"CARDS_LOADING" : "카드 로딩 중 ...",
	"BATTLE_CARDS" : "전투 카드",
	"WINS" : "승리",
	"LOSSES" : "사상자 수",
	"CARD" : "카드",
	"LEVEL" : "수평",
	"TOTAL" : "합계",
	"NO_CARDS" : "카드를 소유하고 있지 않습니다.",
	"INSTALL_EXTENSION" : "<strong>이봐 요!</strong> 설치하고 로그인하십시오. <a href='https://github.com/ChengOrangeJu/WebExtensionWallet' target='_blank'>Nebulas 웹 확장 월렛</a> Battle Blocks 서비스를 사용합니다.",
	"NEBULAS_ERROR" : "<strong>경고!</strong> Nebulas Blockchain에서 데이터를로드하는 중 하나 이상의 오류가 발생했습니다. 다시로드해야 할 수 있습니다.",
	"ERROR_MESSAGE" : "에러 메시지",

	//About Page
	"ABOUT_HEADER" : "Battle Blocks 정보",
	"ABOUT" : "Battle Blocks® 에 만들어진 디지털 자산 카드 게임입니다. <a href='#'>Nebulas</a> 블록 체인. 모든 자산은 블록 체인 (blockchain) 기술로 저장 및 보호되므로 디지털 거래 카드로 쉽고 안전하게 구매, 거래 및 전투 할 수 있습니다.",
	"TOKENS_HEADER" : "전투 토큰",
	"TOKENS" : "승리 할 때마다 5 개의 전투 토큰을 얻습니다. 토큰을 사용하여 카드와 다른 멋진 것들을 개발하십시오 (개발 중). 전투 토큰은 NRC-20에 상응하는 금액으로 교환 될 예정이며, 이관 날짜는 발표 될 예정입니다.",
	"GEN_0_HEADER" : "Generation-0 카드",
	"GEN_0" : "모든 세대는 공급이 제한적이어서 차세대 세대에 비해 장점이 있습니다. Generation-0은 10,000 장의 카드로 제한되며보다 젊은 경쟁자보다 우위를 점할 수있는 독특한 기술과 기술을 이용할 수 있습니다.",
	"GEN_X_HEADER" : "Generation-X 카드",
	"GEN_X" : "Generation-X 카드는 최고 실적자 만 사용할 수 있으며 리더 보드 페이지를 통해 볼 수 있으며 자신의 수입을 경매하기로 결정했는지 여부도 알 수 있습니다. 이 카드는 새로운 예술과 새로운 세대의 기술이 없습니다.",
	"FEES_HEADER" : "Battle Blocks 수수료",
	"FEES_1" : "현재 Nebulas Network Gas Fees를 제외하고는 수수료가 없습니다.",
	"FEES_2" : "경매에는 한정판이나 사용자 할인 가격에 따라 수수료가 부과됩니다.",
	"SUBJECT_TO_CHANGE" : "* 가격은 변경 될 수 있습니다.",

	//Footer
	"FOOTER": {
		"MISSION" : "사명",
		"MISSION_TEXT" : "Blockchain 기반 게임을 재정의하고 혁신하며 품질, 예술가, 엔터테인먼트 및 재미를 높이십시오.",
		"EMAIL_TEXT" : "문의 사항이 있으시면 여기로 이메일을 보내주십시오.",
		"USEFUL_LINKS" : "유용한 링크",
		"RULES" : "규칙",
		"ABOUT" : "약",
		"BATTLES" : "전투",
		"AUCTIONS" : "경매",
		"LEADERBOARDS" : "리더 보드",
		"TERMS_OF_USE" : "이용 약관",
		"SOCIAL" : "사회적인",
		"CONTRACT" : "계약",
	},

	//Auction
	"AUCTION" : {
		"CREATE" : "경매 만들기",
		"LOADING" : "경매 로딩 중 ...",
		"NONE" : "사용 가능한 경매 없음",
		"SOLD" : "판매 된",
		"PRICE" : "가격",
		"CREATED_ON" : "에 만든",
		"BUY" : "사다",
	}

};

export default langKR;


// WEBPACK FOOTER //
// ./src/util/translations/lang_kr.js